export const BASE_PATH = '/';
export const HOME = '/home';
export const DOCS = '/docs';
export const QUESTION_PAPERS_LIST = '/question-papers-list';
export const SCREEN_RESOLVER = '/screen-resolver';

//LOGIN
export const LOGIN = '/login';
export const VERIFY_DETAILS = '/verify-details';
export const ENTER_UID = '/enter-uid';
export const VERIFY_PHONE = '/verify-phone';
export const VERIFY_EMAIL = '/verify-email';
export const SET_PASSWORD = '/set-password';
export const RESET_PASSWORD_OTP = '/reset-password-otp';
export const CHOOSE_PROFILE = '/choose-profile';
export const SWITCH_PROFILE = '/switch-profile';
export const REGISTRATION = '/registration';
export const SELF_REGISTRATION = '/self-registration';
export const USER_NAME_REGISTRATION = '/registration-user-name';
export const SELF_REGISTRATION_FORM = '/self-registration-form';
export const SSO_REDIRECT = '/sso-redirect';

// Homework
export const HOMEWORK_CHAPTER_SELECTION = '/hw-chapters-selection';
export const HOMEWORK_TOPIC_SELECTION = '/hw-topics-selection';
export const HOMEWORK_CREATE = '/homework-create';
export const HOMEWORK_ASSIGN = '/homework-assign';
export const HOMEWORK_MANAGE = '/homework-manage';
export const HOMEWORK_ONGOING = '/homework-ongoing';
export const HOMEWORK_COMPLETED = '/homework-completed';
export const HOMEWORK_REVIEW = '/homework-review';
export const HOMEWORK_QUESTIONBANK = '/homework-questionBank';
export const HOMEWORK_PERFORMANCE = '/performance-homework';
export const HOMEWORK_CONGRATULATIONS = '/homework-congratulations';
export const HOMEWORK_VIEW = '/view-homework';
export const HOMEWORK_CURRENT = '/current-homework';
export const HOMEWORK_CURRENT_CUSTOM = '/current-custom-homework';
export const HOMEWORK_SUBMISSION_CUSTOM = '/submission-custom-hw';

// Learning Homework (demo)
export const LEARNING_HOMEWORK_CHAPTER_SELECTION = '/learning-hw-chapters-selection';
export const LEARNING_HOMEWORK_CREATE = '/learning-hw-create';
export const LEARNING_HOMEWORK_ASSIGN = '/learning-hw-assign';

// Assessment
export const FORMATIVE = '/formative-assessment';
export const QPG = '/question-paper-generator';
export const CHAPTER_TOPIC_SELECTION = '/chapter-topic-selection';
export const HOMEWORK = '/homework-assessment';
export const DIAGNOSTIC = '/diagnostic-assessment';
export const ASSESSMENT_ASSIGN = '/assessment-assign';
export const ASSESMENT_LIBRARY = '/assessment-library';
export const ASSESSMENT_CURRENT = '/current-assessment';
export const ASSESSMENT_VIEW = '/view-assessment';
export const ASSESSMENT_CREATE = '/assessment-create';
export const ASSESSMENT_CONGRATULATIONS = '/assessment-congratulations';
export const ASSESSMENT_REVIEW = '/assessment-review';
export const ASSESSMENT_QUESTIONBANK = '/assessment-question-bank';
export const QPG_ASSESSMENT_CREATE = QPG + ASSESSMENT_CREATE;
export const QPG_ASSESSMENT_REVIEW = QPG + ASSESSMENT_REVIEW;
export const QPG_ASSESSMENT_QUESTION_BANK = QPG + ASSESSMENT_QUESTIONBANK;
export const QPG_ASSESSMENT_PUBLISH = QPG + '-publish';
export const QPG_ASSESSMENT_PUBLISHED = QPG + '-published';
export const QPG_ASSESSMENT_REVIEW_PAPER = QPG + '-review-paper';
export const QPG_ASSESSMENT_CREATION = QPG + '-creation';
export const QPG_QUESTION_BANK = QPG + '-question-bank';
export const QPG_PREVIEW = QPG + '-preview';
export const FA_DRAFT = FORMATIVE + '-draft';
export const FA_CREATION = FORMATIVE + '-creation';
export const FA_REVIEW = FORMATIVE + '-review';
export const FA_PREVIEW = FORMATIVE + '-preview';
export const FA_QUESTION_BANK = FORMATIVE + '-question-bank';
export const FA_ASSIGN_SETTINGS = FORMATIVE + '-assign-settings';

// Clicker Assessment
export const CLICKER_ASSESSMENT_MANAGE = '/clicker-assessment-manage';
export const CLICKER_ASSESSMENT_START = '/clicker-assessment-start';
export const CLICKER_ASSESSMENT = '/clicker-assessment';

// Live Quiz — no dedicated "manage" or "results" route: ending a quiz (like
// Clicker's own "End Test") lands back on HOMEWORK_ONGOING, which shows the
// just-finished attempt via LiveQuizStartTrigger's attempts dropdown
// (OngoingHomework special-cases Live Quiz mode inline, same as OMR mode
// already does).
export const LIVE_QUIZ_START = '/live-quiz-start';
export const LIVE_QUIZ_LOBBY = '/live-quiz-lobby';
export const LIVE_QUIZ_PLAY = '/live-quiz-play';

// OMR
export const OMR_ACTIVE = '/omr-active';

//Analytics
export const ANALYTICS_CLASS_SELECTION = '/analytics-dashboard';
export const ANALYTICS_CLASS_SCORE = '/analytics-classScore';
export const ANALYTICS_CHAPTER_SCORE = '/analytics-chapterScore';
export const ANALYTICS_STUDENT_SCORE = '/analytics-studentScore';

// Teach
export const TEACH_CHAPTER_SELECTION = '/teach-chapters-selection';
export const TEACH_TOPIC_SELECTION = '/teach-topics-selection';
export const LESSON_PLAN_LISTS = '/lesson-plan-lists';
export const TEACHING_FLOW = '/teaching-flow';
export const EDIT_LESSON_PLAN = '/edit-lesson-plan';
export const ADD_RESOURCES = '/add-resources';
export const REPLACE_RESOURCE = '/replace-resource';
export const RESOURCE_PAGE = '/resource';
export const SEEALL_LESSON_PLAN_LIST = '/lessonplan-list';
export const RESOURCE_UPLOAD = '/resource-upload';

// Sidebar
export const NOTIFICATION = '/notifications';
export const HELP = '/help';
export const PROFILE = '/profile';
export const CHANGE_PASSWORD = '/change-password';
export const FAQ = '/faq';
export const DISCLAIMER = '/disclaimer';
export const VERIFY_PASSWORD = '/verify-password';
export const RESET_PASSWORD = '/reset-password';
export const OTP_SCREEN = '/otp-screen';
export const LOGIN_NEW = '/login-new';
export const REPORT = '/report';

//ConnectedClassroom
export const START_CLASSROOM = '/connected-clasroom/start';
export const CONNECTED_CLASS_RESULTS = '/connected-clasroom/results';
export const LOGIN_PASSWORD = '/login_password';
export const PROFILE_OTP_SCREEN = '/profile-otp-screen';

//Offline
export const OFFLINE_TEACH_CHAPTER_SELECTION =
  '/offline/teach-chapters-selection';
export const OFFLINE_TEACH_TOPIC_SELECTION = '/offline/teach-topics-selection';
export const OFFLINE_LESSON_PLAN_LISTS = '/offline/lesson-plan-lists';
export const OFFLINE_TEACHING_FLOW = '/offline/teaching-flow';
export const OFFLINE_RESOURCE = '/offline/resource';
export const DOWNLOAD_SETTINGS = '/download-settings';

// MCB Login
export const MCB_LOGIN = '/mcb-login';
export const MCB_APP_LOGIN = '/mcb-app-login';

// Demo
export const DEMO_FORMATIVE_QPG = '/demo-formative-qpg';
export const DEMO_RESOURCE_QPG_DOWNLOAD = '/demo/resource-qpg-download';
//QuestionBank
export const QUESTION_BANK = '/question-bank';

//Laboratory
export const Project_Dashboard = '/project-dashboard'
export const Create_Project = '/create-project'
export const Assign_project = '/assign-project'
export const View_Project = '/view-project'
export const Project_Congratulations = '/project-congratulations'
//GIL Reports - class > project > group, and a student's own dashboards
export const GIL_Reports = '/gil-reports'
export const GIL_Reports_Project = '/gil-reports/project'
export const GIL_Reports_Group = '/gil-reports/group'
export const GIL_Reports_Student = '/gil-reports/student'
export const GIL_Reports_Student_Project = '/gil-reports/student-project'
